export const ENDPOINTS = {
  getHotels: '/gateway/extranet/hotels',
  getHotelPacks: '/gateway/extranet/:id/packs',
  getHotelExperiences: '/gateway/extranet/:id/experiences',
  getHotelRooms: '/gateway/extranet/:id/rooms',
} as const;

export const CORE_QUERY_KEYS = {
  hotels: 'extranet-hotels',
  hotelPacks: 'extranet-hotel-packs',
  hotelExperiences: 'extranet-hotel-experiences',
  hotelRooms: 'extranet-hotel-rooms',
} as const;
